const storageDefaultKey = 'deezer';
export default class Storage {
  constructor() {
    this.isStorageSupported = void 0;

    try {
      localStorage.setItem(storageDefaultKey, 'test');
      localStorage.removeItem(storageDefaultKey);
      this.isStorageSupported = true;
    } catch (_unused) {
      this.isStorageSupported = false;
    }
  }

  isset(key) {
    if (!this.isStorageSupported) {
      return false;
    }

    return Boolean(typeof localStorage[key] !== 'undefined' && localStorage[key] !== null);
  }

  get(key, defaultValue) {
    if (!this.isStorageSupported) {
      return defaultValue;
    }

    if (!this.isset(key)) {
      return defaultValue;
    }

    const item = localStorage.getItem(key);
    if (!item) return defaultValue;
    return JSON.parse(item);
  }

  set(key, value) {
    if (!this.isStorageSupported) {
      return false;
    }

    localStorage.setItem(key, JSON.stringify(value));
    return true;
  }

  remove(key) {
    if (!this.isStorageSupported) {
      return;
    }

    localStorage.removeItem(key);
  }

  get length() {
    return this.isStorageSupported ? localStorage.length : 0;
  }

}
//# sourceMappingURL=index.js.map